{
  "bookingWidgetTabs": {
    "hotels": {
      "tabTitle": "Hotellit",
      "ctaText": "Katso hotellitarjoukset",
      "poweredBy": "Palvelun tarjoaa",
      "staticNotification": {
        "content": "Tutustu kumppanimme hotellitarjouksiin ympäri maailman.",
        "redirect": "Ohjaamme sinut Hotels.comin englanninkielisille verkkosivuille."
      }
    }
  },
  "bookingWidget": {
    "hotels": {
      "aviosNotification": "Finnair Plus -jäsenet voivat kerätä Avioksia jokaisesta hotellivarauksesta."
    }
  }
}
